import toggleClass from "./toggleClass.js";

export default (elem, classes) => toggleClass(elem, classes, true);
